import React, { Component } from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';
import {resetSearchPropertyMarker, showModal} from '../../actions';
import LocationTypeahead from '../Typeahead/LocationTypeahead';
import SearchFilter from '../Home/SearchFilter';
import {searchAddressFormatting} from '../../lib/formatting';
import {createSearchURL} from '../../lib/createSearchURL';
import {addressParams} from '../../lib/urlTools';
import {trackShowFilters} from '../../lib/tracking';
import styles from './SearchBox.scss';
import universal from 'react-universal-component';
import {importOptions} from '../../lib/universalImport';
const MobileFilters = universal(import('./MobileFilters'), importOptions);

class SearchBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      prefillAddress: null,
    };
    this.toggleMobileFilter = this.toggleMobileFilter.bind(this);
  }

  componentDidMount() {
    this.setState({prefillAddress: this.getPrefillAddress()});
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.filterSearch.address.pretty !== this.props.filterSearch.address.pretty) {
      if (this.props.filterSearch.address.pretty) {
        this.setState({prefillAddress: this.props.filterSearch.address.pretty});
      } else {
        this.setState({prefillAddress: this.getPrefillAddress()});
      }
    }
  }

  getPrefillAddress = () => {
    let addrParams = addressParams(this.props.match.params, this.props.location.search);
    return searchAddressFormatting(addrParams);
  }

  submitSearch = () => {
    let searchURL = createSearchURL(this.props.filterSearch);
    // close any infowindows
    this.props.resetSearchPropertyMarker();
    this.props.history.push(searchURL);
  }

  toggleMobileFilter = () => {
    this.props.showModal({
      open: true,
      className: styles.filterModal,
      component: <MobileFilters prefillAddress={this.state.prefillAddress} handleSearchSubmission={this.submitSearch} currentTab={this.state.currentTab} changeTab={this.changeTab} closeModal={this.toggleMobileFilter}/>
    });
    trackShowFilters(this.props.filterSearch);
  }

  render() {
    return (
      <div className={`d-flex align-items-center ${styles.searchBox}`}>
        <div className="d-flex flex-grow-1">
          <div className="position-relative flex-grow-1">
            <LocationTypeahead id="searchTA" prefillAddress={this.state.prefillAddress} submitSingleResult={true} submitFunction={this.submitSearch} size="large" />
            <i className={styles.mobileFilterIcon} onClick={this.toggleMobileFilter} />
          </div>
          <button onClick={this.submitSearch} className={`btn btn-primary position-relative ${styles.searchButton}`}/>
        </div>
        <div className={styles.searchFilters}>
          <div className={styles.searchFilterBig}>
            <SearchFilter layout="results" presetFilters={this.props.searchParams} searchFunction={this.submitSearch} toggleMoreFilters={this.props.toggleMoreFilters} moreFiltersOpen={this.props.moreFiltersOpen} />
          </div>
        </div>
      </div>
    );
  }
}

SearchBox.propTypes = {
  searchParams: PropTypes.object.isRequired,
  toggleMoreFilters: PropTypes.func,
  moreFiltersOpen: PropTypes.bool,
  showModal: PropTypes.func,
};

const mapStateToProps = (state) => ({
  filterSearch: state.filterSearch,
  addressSearch: state.addressSearch.content,
});
const mapDispatchToProps = {resetSearchPropertyMarker, showModal};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SearchBox));
